import { render, staticRenderFns } from "./NotificationStatusChange.vue?vue&type=template&id=159054a8&scoped=true&lang=pug&"
import script from "./NotificationStatusChange.vue?vue&type=script&lang=js&"
export * from "./NotificationStatusChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159054a8",
  null
  
)

export default component.exports